import React, { Component, Fragment } from 'react';
import axios from "axios";
import { Input, Row, Col, FormFeedback, Label } from 'reactstrap';

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import api from '../../api/';
import auth from '../../auth/';
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import DetailEmpresa from '../clientes/Empresas/Detail.js';
import DetailSolicitud from '../Proyectos/Procedimiento1/Detail.js';
import DetailPlanDeTrabajo from '../Proyectos/Procedimiento2/Detail.js';
import DetailPresupuesto from '../Proyectos/Procedimiento3/Detail.js';

var codeField = {
  maxWidth: "150px"
}

var valueField = {
  maxWidth: "400px"
}

var divLabel = {
  display: "flex",
  alignItems: "center",
}

class Visualizador extends Component {
  constructor() {
    super();
    this.state = {
      proyecto_nombre: "",
      proyecto_data: null,
      proyecto_codigo: "",
      presupuesto_codigo: ""
    };
  }

  SetProyecto(value) {
    if (value != null) {
      this.setState({
        proyecto_codigo: value.codigo,
        presupuesto_codigo: value.cod,
        proyecto_nombre: value.nombre,
        proyecto_data: null,
      });
      this.LoadProyecto(value.codigo);
    }
    else
      this.setState({
        proyecto_codigo: "",
        presupuesto_codigo: "",
        proyecto_nombre: "",
        proyecto_data: null,
      });

  }

  LoadProyecto(codigo) {
    var url = api.proyectos.solicitudes.history + "?codigo=" + codigo;
    axios.get(url, auth.header())
      .then((response) => {
        if (response.data.success)
          this.setState({ proyecto_data: response.data.proyecto });
      });
  }

  parseDate(stringdate) {
    var date = new Date(stringdate);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var mins = date.getMinutes();

    if (month < 10)
      month = "0" + month;
    if (day < 10)
      day = "0" + day;
    if (hour < 10)
      hour = "0" + hour;
    if (mins < 10)
      mins = "0" + mins;

    return day + "/" + month + "/" + year + " " + hour + ":" + mins;
  }

  render() {
    var items = [];

    if (this.state.proyecto_data != null) {
      var proyecto_data = this.state.proyecto_data;

      var solicitud = proyecto_data['solicitud'];
      let fecha_str = this.parseDate(solicitud.fecha);
      var imputacion = proyecto_data['imputacion'];

      /**Solicitud */
      items.push(
        <VerticalTimelineElement
          key={`item-${items.length}`}
          className="vertical-timeline-element--work info"
          date={fecha_str}
          dateClassName='text-dark'
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<label>1</label>}
          position={"left"}
        >
          <div className={"float-right"}>
            <DetailEmpresa id={() => { return solicitud.empresa_id }} />
          </div>
          <h3 className="vertical-timeline-element-title">Solicitud - Contacto Cliente</h3>
          <p>
            Empresa: {solicitud.empresa_razonSocial}
          </p>
          {
            solicitud.lte &&
            <Fragment>
              <p>Nombre: {solicitud.lte}</p>
              <p>Email: {solicitud.lte_email}</p>
            </Fragment>
          }
        </VerticalTimelineElement>
      );

      if (solicitud.lte != null) {
        items.push(
          <VerticalTimelineElement
            key={`item-${items.length}`}
            className="vertical-timeline-element--work success"
            dateClassName='text-dark'
            date={this.parseDate(solicitud.fechaAsignado)}
            iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
            icon={<label>2</label>}
            position={"right"}
          >
            <div className={"float-right"}>
              <DetailSolicitud id={() => { return solicitud.pk }} />
            </div>
            <h3 className="vertical-timeline-element-title">Solicitud - Análisis</h3>
            <p>LTE: {solicitud.lte}</p>
            <p>LTP: {solicitud.ltp}</p>
          </VerticalTimelineElement>
        );
      }

      if (solicitud.estado_id == "1") {
        items.push(
          <VerticalTimelineElement
            key={`item-${items.length}`}
            className="vertical-timeline-element--work danger"
            dateClassName='text-dark'
            date={this.parseDate(solicitud.fechaDesestimado)}
            iconStyle={{ background: 'rgb(202, 18, 18)', color: '#fff' }}
            icon={<label>{solicitud.lte ? 2.1 : 2}</label>}
            position={"right"}
          >
            <div className={"float-right"}>
              <DetailSolicitud id={() => { return solicitud.pk }} />
            </div>
            <h3 className="vertical-timeline-element-title">Solicitud - Desestimada</h3>
            <small className="vertical-timeline-element-subtitle">{solicitud.userDesestimado}</small>
            <p>{solicitud.motivo}</p>
          </VerticalTimelineElement>
        );
      }

      /**Plan de trabajo */
      var fechaAceptado = null;
      var planes = proyecto_data.planesdetrabajo;
      for (var i = 0; i < planes.length; i++) {
        var plangroup = planes[i];
        var plan = plangroup.plan;
        let fecha_plan = this.parseDate(plan.fecha);

        items.push(
          <VerticalTimelineElement
            key={`item-${items.length}`}
            className="vertical-timeline-element--work info"
            dateClassName='text-dark'
            date={fecha_plan}
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<label>3</label>}
            position={"left"}
          >
            <div className={"float-right"}>
              <DetailPlanDeTrabajo id={() => { return plan.pk }} />
            </div>
            <h3 className="vertical-timeline-element-title">Plan de Trabajo - Elaborado</h3>
            <p>{plan.observaciones}</p>
          </VerticalTimelineElement>
        );

        var presupuestos = plangroup.presupuesto;
        /**Presupuestos */
        for (var pres = 0; pres < presupuestos.length; pres++) {
          let presupuesto = presupuestos[pres];
          let fecha_presupuesto = this.parseDate(presupuesto.fecha);
          let etapa = (presupuesto.cantEtapas != null && presupuesto.cantEtapas > 1) ? ('E. ' + presupuesto.etapa + '/' + presupuesto.cantEtapas) : ('');
          items.push(
            <VerticalTimelineElement
              key={`item-${items.length}`}
              className="vertical-timeline-element--work info"
              dateClassName='text-dark'
              date={fecha_presupuesto}
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<label>4</label>}
              position={"right"}
            >
              <div className={"float-right"}>
                <DetailPresupuesto id={() => { return presupuesto.pk }} />
              </div>
              <h3 className="vertical-timeline-element-title">Presupuesto {etapa} - Elaborado</h3>
            </VerticalTimelineElement>
          );

          if (presupuesto.enviadoOTT) {
            items.push(
              <VerticalTimelineElement
                key={`item-${items.length}`}
                className="vertical-timeline-element--work info"
                dateClassName='text-dark'
                date={this.parseDate(presupuesto.fechaEnviadoOTT)}
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<label>4.1</label>}
                position={"right"}
              >
                <div className={"float-right"}>
                  <DetailPresupuesto id={() => { return presupuesto.pk }} />
                </div>
                <h3 className="vertical-timeline-element-title">Presupuesto {etapa} - Enviado a la OTT</h3>
              </VerticalTimelineElement>
            );
          }

          if (presupuesto.enviadoUVT) {
            items.push(
              <VerticalTimelineElement
                key={`item-${items.length}`}
                className="vertical-timeline-element--work info"
                dateClassName='text-dark'
                date={this.parseDate(presupuesto.fechaEnviadoUVT)}
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<label>4.2</label>}
                position={"right"}
              >
                <div className={"float-right"}>
                  <DetailPresupuesto id={() => { return presupuesto.pk }} />
                </div>
                <h3 className="vertical-timeline-element-title">Presupuesto {etapa} - Enviado a la UVT</h3>
              </VerticalTimelineElement>
            );
          }

          if (presupuesto.rechazado && !presupuesto.represupuestado) {
            items.push(
              <VerticalTimelineElement
                key={`item-${items.length}`}
                className="vertical-timeline-element--work danger"
                dateClassName='text-dark'
                date={this.parseDate(presupuesto.fechaRechazado)}
                iconStyle={{ background: 'rgb(202, 18, 18)', color: '#fff' }}
                icon={<label>{presupuesto.enviadoOTT ? 4.3 : 4.2}</label>}
                position={"right"}
              >
                <div className={"float-right"}>
                  <DetailPresupuesto id={() => { return presupuesto.pk }} />
                </div>
                <h3 className="vertical-timeline-element-title">Presupuesto {etapa} - Rechazado</h3>
                <p>{presupuesto.motivo}</p>
              </VerticalTimelineElement>
            );
          }
          else if (presupuesto.represupuestado) {
            items.push(
              <VerticalTimelineElement
                key={`item-${items.length}`}
                className="vertical-timeline-element--work warning"
                dateClassName='text-dark'
                date={this.parseDate(presupuesto.fechaRachazado)}
                iconStyle={{ background: 'rgb(220, 169, 21)', color: '#fff' }}
                icon={<label>{presupuesto.enviadoOTT ? 4.3 : 4.2}</label>}
                position={"right"}
              >
                <div className={"float-right"}>
                  <DetailPresupuesto id={() => { return presupuesto.pk }} />
                </div>
                <h3 className="vertical-timeline-element-title">Presupuesto {etapa} - Modificado</h3>
              </VerticalTimelineElement>
            );
          }
          else if (presupuesto.estado >= 5) {
            fechaAceptado = this.parseDate(presupuesto.fechaAceptado);
            items.push(
              <VerticalTimelineElement
                key={`item-${items.length}`}
                className="vertical-timeline-element--work success"
                dateClassName='text-dark'
                date={this.parseDate(presupuesto.fechaAceptado)}
                iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
                icon={<label>{presupuesto.represupuestado ? 4.4 : 4.3}</label>}
                position={"right"}
              >
                <div className={"float-right"}>
                  <DetailPresupuesto id={() => { return presupuesto.pk }} />
                </div>
                <h3 className="vertical-timeline-element-title">Presupuesto {etapa} - Aceptado</h3>
              </VerticalTimelineElement>
            );
          }

          /**Informes */
          if (presupuesto.estado >= 6) {
            items.push(
              <VerticalTimelineElement
                // key={items.length.toString()}
                key={`item-${items.length}`}
                className="vertical-timeline-element--work info"
                dateClassName='text-dark'
                date={fechaAceptado}
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<label>5</label>}
                position={"left"}
              >
                <h3 className="vertical-timeline-element-title">Ejecución {etapa} - Inicio</h3>
              </VerticalTimelineElement>
            );
            let informeSolicitud = presupuesto.informeSolicitud;
            if (informeSolicitud != null && presupuesto.estado > 6) {
              items.push(
                <VerticalTimelineElement
                  key={`item-${items.length}`}
                  className="vertical-timeline-element--work success"
                  dateClassName='text-dark'
                  date={this.parseDate((informeSolicitud.fecha != null) ? (informeSolicitud.fecha) : (informeSolicitud.fechaInforme))}
                  iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
                  icon={<label>5.1</label>}
                  position={"left"}
                >
                  <h3 className="vertical-timeline-element-title">Ejecución {etapa} - Finalización</h3>
                </VerticalTimelineElement>
              );

              if (informeSolicitud.emiteinforme == true) {
                items.push(
                  <VerticalTimelineElement
                    key={`item-${items.length}`}
                    className="vertical-timeline-element--work success"
                    dateClassName='text-dark'
                    date={this.parseDate((informeSolicitud.fecha != null) ? (informeSolicitud.fecha) : (informeSolicitud.fechaInforme))}
                    iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
                    icon={<label>6</label>}
                    position={"right"}
                  >
                    <h3 className="vertical-timeline-element-title">Informe {etapa} - Cargado</h3>
                    <a className="text-white" target={"_blank"} href={api.BASE_URL + informeSolicitud.url}>DESCARGAR</a>
                  </VerticalTimelineElement>
                );
              } else {
                items.push(
                  <VerticalTimelineElement
                    key={`item-${items.length}`}
                    className="vertical-timeline-element--work danger"
                    dateClassName='text-dark'
                    date={this.parseDate((informeSolicitud.fecha != null) ? (informeSolicitud.fecha) : (informeSolicitud.fechaInforme))}
                    iconStyle={{ background: 'rgb(202, 18, 18)', color: '#fff' }}
                    icon={<label>6</label>}
                    position={"right"}
                  >
                    <h3 className="vertical-timeline-element-title">Informe {etapa} - No emitió informe</h3>
                  </VerticalTimelineElement>
                );
              }

              if (presupuesto.estado > 11) {
                var fechaMailEnviado = informeSolicitud.fechaMailEnviado;
                items.push(
                  <VerticalTimelineElement
                    key={`item-${items.length}`}
                    className="vertical-timeline-element--work success"
                    dateClassName='text-dark'
                    date={this.parseDate(fechaMailEnviado)}
                    iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
                    icon={<label>6.1</label>}
                    position={"right"}
                  >
                    <h3 className="vertical-timeline-element-title">Informe {etapa} - Enviado al Cliente</h3>
                  </VerticalTimelineElement>
                );
              }
            }

            /**Certificaciones */
            let certificacionPresupuesto = presupuesto.certificacionPresupuesto;
            if (certificacionPresupuesto != null && presupuesto.estado >= 9) {

              if ((presupuesto.certificacionUnica == false) || (pres == (presupuestos.length - 1))) {
                items.push(
                  <VerticalTimelineElement
                    key={`item-${items.length}`}
                    className="vertical-timeline-element--work info"
                    dateClassName='text-dark'
                    date={this.parseDate(certificacionPresupuesto.fechaCertificacion)}
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={<label>7</label>}
                    position={"left"}
                  >
                    <h3 className="vertical-timeline-element-title">Certificación {(presupuesto.certificacionUnica == false) && etapa} - Solicitada </h3>
                  </VerticalTimelineElement>
                );

                if (certificacionPresupuesto.certificacionAutorizada) {
                  items.push(
                    <VerticalTimelineElement
                      key={`item-${items.length}`}
                      className="vertical-timeline-element--work success"
                      dateClassName='text-dark'
                      date={this.parseDate(certificacionPresupuesto.fechaCertificacionAutorizada)}
                      iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
                      icon={<label>7.1</label>}
                      position={"left"}
                    >
                      <h3 className="vertical-timeline-element-title">Certificación {(presupuesto.certificacionUnica == false) && etapa} - Autorizada</h3>
                    </VerticalTimelineElement>
                  );
                }
              }
            }

            /**Mail Pedido Factura */
            if (presupuesto.estado >= 10 && informeSolicitud && informeSolicitud.fechaMailPedidoFactura) {
              items.push(
                <VerticalTimelineElement
                  key={`item-${items.length}`}
                  className="vertical-timeline-element--work info"
                  dateClassName='text-dark'
                  date={this.parseDate(informeSolicitud.fechaMailPedidoFactura)}
                  iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                  icon={<label>8</label>}
                  position={"right"}
                >
                  <h3 className="vertical-timeline-element-title">Facturación {etapa} - Solicitada</h3>
                </VerticalTimelineElement>
              );
            }
          }
        }
      }

      if (imputacion && imputacion.length > 0) {
        let imp = imputacion[0];
        items.push(
          <VerticalTimelineElement
            key={items.length.toString()}
            className="vertical-timeline-element--work info"
            dateClassName='text-dark'
            date={this.parseDate(imp.date)}
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            icon={<label>{9.1}</label>}
            position={"left"}
          >
            <h3 className="vertical-timeline-element-title">{imp.title}</h3>
          </VerticalTimelineElement>
        )
        if (imputacion.length > 1) {
          imp = imputacion[1];
          items.push(
            <VerticalTimelineElement
              key={items.length.toString()}
              className="vertical-timeline-element--work success"
              dateClassName='text-dark'
              date={this.parseDate(imp.date)}
              iconStyle={{ background: 'rgb(18, 197, 75)', color: '#fff' }}
              icon={<label>{9.2}</label>}
              position={"left"}
            >
              <h3 className="vertical-timeline-element-title">{imp.title}</h3>
            </VerticalTimelineElement>
          )
        }
      }
    }

    return (
      <div>
        <div className="row mt-1">
          <div style={divLabel}>
            <Label>Proyecto</Label>
          </div>
          <div className="col-3" style={codeField}>
            <ParadigmaAsyncSeeker
              pkField={"cod"}
              nombreField={"cod"}
              fieldName={""}
              url={api.proyectos.solicitudes.selectcodigo}
              value={this.state.presupuesto_codigo}
              onChange={(value) => this.SetProyecto(value)} />
          </div>
          <div className="col-5" style={valueField}>
            <ParadigmaAsyncSeeker
              pkField={"codigo"}
              fieldName={""}
              url={api.proyectos.solicitudes.selectcodigo}
              value={this.state.proyecto_codigo}
              onChange={(value) => this.SetProyecto(value)} />
          </div>
        </div>
        <div className="row">
          <VerticalTimeline>
            {items}
          </VerticalTimeline>
        </div>
      </div >
    );
  }
}

export default Visualizador;



// WEBPACK FOOTER //
// ./src/views/Indicadores/VisualizadorProyectos.js